export default {
  sections: {
    setup_fee: {
      title: 'Opsætningsomkostninger',
      description: 'Opsætningsomkostninger fra {{amount}} – i stedet for 1.000+',
    },
  },
  labels: {
    month: 'Måned (netto)',
    one_time_fee: 'Engangsgebyr',
    more_options: 'Flere muligheder',
    discount_badge: '-{{percentage}}%',
  },
  features: {
    app: 'Din egen app i App Store og Google Play',
    push_notifications: 'Push-notifikationer om tilbud',
    loyalty: 'Kundeloyalitet gennem loyalitetsprogrammer',
    offline_orders: 'Offlinebestillinger mulige',
    individual_design: 'Individuelt appdesign',
  },
  setup_fee_options: {
    150: 'Standardopsætning',
    75: 'Reduceret',
    0: 'Ingen oprettelsesomkostninger',
  },
  feedback: {
    contract_signed_already: {
      title: 'Kontrakten er allerede underskrevet',
      description: 'Kontakt teknisk support, hvis du skal foretage ændringer',
    },
  },
};
